import "./Home.css";
import { SectionWrapper } from "../../hoc";
import { Head, About, OurProject, OurSolution } from "./sections";

const Home = () => {
  return (
    <>
      <div
        className="bg-[var(--purple-white)] overflow-hidden"
        style={{ zIndex: 0 }}
      >
        <div className="relative">
          <Head />
          <div className="gradient-head" />
        </div>
        <div className="relative aboutsection">
          <About />
          <div className="gradient-03" />
        </div>
        <div className="relative projectsection">
          <OurProject />
          <div className="gradient-04" />
        </div>
        <div className="relative projectsection lastpart">
          <OurSolution />
          <div className="gradient-03" />
        </div>
      </div>
    </>
  );
};

export default SectionWrapper(Home, "home");
